<template>
  <div class="row">
    <div :class="`col-${customCols.leftCol} d-flex align-items-center`">
      <p class="h1 m-0">{{ title }}</p>
    </div>
    <div :class="`col-${customCols.rightCol}`">
      <div class="d-flex gap-1">
        <slot name="title-details"></slot>
        <div class="col-3">
          <button
            v-if="showAddNew"
            @click="$emit('onClickAddNewBtn')"
            class="btn btn-outline-primary w-100"
          >
            {{ btnTitle }}
          </button>
        </div>

        <div class="col-3">
          <button
            v-if="showSecondBtn"
            @click="$emit('onClickSecondBtn')"
            class="btn btn-outline-primary w-100"
          >
            {{ secondBtnTitle }}
          </button>
        </div>

        <div class="col-3">
          <button
            v-if="showThirdBtn"
            @click="$emit('onClickThirdBtn')"
            class="btn btn-primary w-100"
          >
            {{ thirdBtnTitle }}
          </button>
        </div>

        <div class="col-2 d-flex justify-content-center align-items-center">
          <button
            v-if="showBtn"
            @click="$emit('onClickCloseButton')"
            class="btn btn-close"
          >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleButton',
  props: {
    title: String,
    btnTitle: String,
    secondBtnTitle: String,
    thirdBtnTitle: String,
    showBtn: {
      default: true
    },
    showAddNew: {
      default: false
    },
    showSecondBtn: {
      default: false
    },
    showThirdBtn: {
      default: false
    },
    showFilterBtn: {
      default: false
    },
    customCols: {
      type: Object || null,
      default: {
        leftCol: 6,
        rightCol: 6
      }
    }
  }
}
</script>

<style scoped>
.cancel-btn {
  background-color: #F0F2F5;
  color: #7D7D7D;
}

.mr {
  margin-right: 1rem;
}

.cancel-btn:hover {
  background-color: #e9edf5;
}

hr {
  margin: 0 -3%;
  width: 106%;
}

@media screen and (min-width: 1200px) {
  .btn-close {
    background-color: #E4E6EB;
    border-radius: 50%;
  }

  .btn-close:hover {
    width: 30px;
    height: 30px;
    background-color: #D8DADF;
    border-radius: 50%;
  }
}

@media screen and (max-width: 720px) {
  .btn-close {
    width: 25px;
    height: 25px;
    background-color: #E4E6EB;
    border-radius: 50%;
    margin-top: -5px;
    margin-right: -5px;
  }
}
</style>
